import "./App.css";
import { Route, Routes } from "react-router-dom";
import { NotificationProvider } from "./contexts/NotificationContext";
import Home from "./pages/Home";
import NotificationsPage from "./pages/Notifications";

function App() {
  return (
    <NotificationProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<Home />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Routes>
    </NotificationProvider>
  );
}

export default App;
